'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function HKFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-2vdngnshj", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-2pg7cgjxt", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-j48l8ids8" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-j48l8ids8", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-2vdngnshj)" }, /* @__PURE__ */ React.createElement("use", { fill: "#ea1a1a", xlinkHref: "#mantine-j48l8ids8" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        d: "M18.238 11.827s7.432 2.225 2.448 7.877c0 0-2.76-1.158-2.448-4.05.312-2.892.89-3.516 0-3.827zm-1.953 1.735s1.332 7.642-5.951 5.71c0 0-.199-2.985 2.528-4 2.726-1.014 3.542-.775 3.423-1.71zm-4.527-4.04c1.5 2.379 1.488 3.25 2.29 3.027l.08-.025-.01.004c-.373.144-7.18 2.658-6.793-4.66 0 0 2.881-.807 4.433 1.654zm13.72.753s-1.679 2.476-4.453 1.6c-2.774-.877-3.27-1.567-3.751-.757 0 0 3.65-6.845 8.205-.843zm-8.49-6.872s2.01 2.217.503 4.705c-1.508 2.489-2.296 2.808-1.621 3.467 0 0-.06-.053-.16-.151l-.081-.083c-1.022-1.039-4.675-5.31 1.36-7.938z",
        mask: "url(#mantine-2pg7cgjxt)"
      }
    ), /* @__PURE__ */ React.createElement("g", { fill: "#ea1a1a" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M9.95 10.342l.422-.268c.927 1.458 2.129 2.175 3.63 2.175v.5c-1.68 0-3.037-.81-4.052-2.407z",
        mask: "url(#mantine-2pg7cgjxt)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M21.75 10.75a.75.75 0 100-1.5.75.75 0 000 1.5zm-1.791 4.978a.75.75 0 100-1.5.75.75 0 000 1.5zm-6 2a.75.75 0 100-1.5.75.75 0 000 1.5zm-4-7a.75.75 0 100-1.5.75.75 0 000 1.5zm6-3a.75.75 0 100-1.5.75.75 0 000 1.5z",
        mask: "url(#mantine-2pg7cgjxt)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M13.609 8.303l.417-.276c.965 1.456 2.188 2.173 3.69 2.173v.5c-1.677 0-3.053-.806-4.107-2.397z",
        mask: "url(#mantine-2pg7cgjxt)",
        transform: "rotate(62 15.662 9.364)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M17.538 9.266l.417-.275c1.089 1.651 2.375 2.463 3.873 2.463v.5c-1.68 0-3.115-.905-4.29-2.688z",
        mask: "url(#mantine-2pg7cgjxt)",
        transform: "rotate(132 19.683 10.472)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M16.67 12.236l.417-.275c1.088 1.651 2.374 2.463 3.872 2.463v.5c-1.68 0-3.115-.905-4.29-2.688z",
        mask: "url(#mantine-2pg7cgjxt)",
        transform: "rotate(-158 18.814 13.442)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M13.042 13.842l.418-.275c1.088 1.651 2.374 2.463 3.872 2.463v.5c-1.68 0-3.115-.905-4.29-2.688z",
        mask: "url(#mantine-2pg7cgjxt)",
        transform: "rotate(-88 15.187 15.048)"
      }
    ))))
  );
}

export { HKFlag };
//# sourceMappingURL=HK.mjs.map
